import { styled } from '@mui/system';
import { fm } from 'Components/FormatMessage';
import * as React from 'react';
import colors from '../../../config/theme/colors';
import ActionButton from '../../ActionButton';
import { Container, Item } from '../../Grid';

const StyledCancel = styled('a')({
  fontSize: '1.6rem',
  fontWeight: 600,
  cursor: 'pointer',
  color: colors.primary,
  textTransform: 'uppercase',
  marginRight: '2rem',
});

const EditingEvent = ({
  editingElements,
  thisIndex,
  thisOnChange,
  cancel,
  save,
  saveDisabled,
  saveDisabledMessage,
}: IOwnProps): React.JSX.Element => (
  <div style={{ backgroundColor: colors.lightestGray, padding: '2rem 2rem 2rem 5rem' }}>
    {editingElements(thisIndex, thisOnChange)}
    <Container alignItems="center" justifyContent="flex-end">
      <Item>{cancel && <StyledCancel onClick={cancel}>{fm('general.cancel')}</StyledCancel>}</Item>
      <Item>
        <ActionButton
          text="general.accept"
          onClick={() => save()}
          width={12}
          height={3}
          fontSize={16}
          disabled={saveDisabled}
          disabledTooltip={
            typeof saveDisabledMessage === 'string' ? <span>{saveDisabledMessage}</span> : saveDisabledMessage
          }
        />
      </Item>
    </Container>
  </div>
);

interface IOwnProps {
  editingElements: (i: number, onChange: IFormData['onChange']) => React.JSX.Element;
  thisIndex: number;
  thisOnChange: IFormData['onChange'];
  cancel?: () => void;
  save: () => void;
  saveDisabled?: boolean;
  saveDisabledMessage?: string | React.JSX.Element;
}

export default EditingEvent;
